import { memo } from 'react';

import type { ErrorCode, FileRejection } from 'react-dropzone-latest';

import { getDropzoneErrorMessage } from './functions';

export interface DropzoneErrorsProps {
  rejectedFiles?: FileRejection[];
}

const DropzoneErrors = ({ rejectedFiles }: DropzoneErrorsProps) => {
  if (!rejectedFiles?.length) {
    return null;
  }

  const messages = rejectedFiles.map(({ file, errors }) => (
    <li key={file.name} className="padding">
      {file.name} - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code} className="text-danger">
            {getDropzoneErrorMessage(e.code as ErrorCode) || translate(e.message)}
          </li>
        ))}
      </ul>
    </li>
  ));

  const caption = translate('The following files can not be uploaded:');

  return (
    <div>
      <div>{caption}</div>
      {messages}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(DropzoneErrors);
